import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup, FormArray } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-new-update-profile',
  templateUrl: './new-update-profile.component.html',
  styleUrls: ['./new-update-profile.component.scss']
})
export class NewUpdateProfileComponent implements OnInit {
  edit_profile: FormGroup
  user_image: any;
  user_email: any;
  company_name: any;
  profile_pic_url_selected = 0;
  submitted = false;
  imgUrl = environment.ImageUrl;
  global_user_id: any;
  profile_pic_url: any;
  profile_pic_path: any;
  selected_profile_pic: File;

  constructor(
    private fb: FormBuilder,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.edit_profile = this.fb.group({
      first_name: ["", [Validators.required]],
      last_name: ["", [Validators.required]],
      job_title: ["", [Validators.required]],
      phone_number: [""],
      whatsapp_number: ["", [Validators.required, Validators.minLength(7)]],
      // telegram_id: ["", [Validators.required]]
    });

    this.route.params.subscribe(params => {
      this.global_user_id = params.id;
      this.get_user_details_data();
    });
  }

  get edit_profile_v() { return this.edit_profile.controls }

  get_user_details_data() {
    let formData = new FormData();
    formData.append('id', this.global_user_id);

    this.auth.get_other_user_details_data(formData).subscribe((response: any) => {

      this.user_image = response.body.image;
      this.user_email = response.body.email;
      this.company_name = response.body.user_detail.job_title;

      this.edit_profile = this.fb.group({
        first_name: [response.body.user_detail.first_name, [Validators.required]],
        last_name: [response.body.user_detail.last_name, [Validators.required]],
        job_title: [response.body.user_detail.job_title, [Validators.required]],
        phone_number: [response.body.user_detail.phone_number],
        whatsapp_number: [response.body.user_detail.w_phone_number, [Validators.required]],
        // telegram_id: [response.body.user_detail.telegram_user_id, [Validators.required]]
      });

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });
  }

  update_profile() {
    this.submitted = true;

    if(this.edit_profile.invalid) {
      return false;
    }

    let formData = new FormData();
    formData.append('userId', this.global_user_id),
    formData.append('first_name', this.edit_profile_v.first_name.value);
    formData.append('last_name', this.edit_profile_v.last_name.value);
    formData.append('job_title', this.edit_profile_v.job_title.value);
    // formData.append('country_code', '+65');
    formData.append('phone_number', this.edit_profile_v.phone_number.value);
    formData.append('w_country_code', '+65');
    formData.append('w_phone_number', this.edit_profile_v.whatsapp_number.value);
    // formData.append('telegram_user_id', this.edit_profile_v.telegram_id.value);
    formData.append('image', this.selected_profile_pic);

    this.auth.update_other_user_details(formData).subscribe((response: any) => {

      this.toastr.success(response.message);

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });
  }

  onImageSelected(files, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.profile_pic_url = event.target.result;
        this.profile_pic_url_selected = 1;
      }
      reader.readAsDataURL(event.target.files[0]);
    }

    this.profile_pic_path = files;
    this.selected_profile_pic = <File>files[0];
  }

  back() {
    this.router.navigate(['/admin/sub-admins']);
  }

}
